export default __webpack_public_path__ + "static/1487-a9e21c960484df9a2991fb9f88273384.gif";